import { render } from "./InfractionDetailsPage.vue?vue&type=template&id=6b117c0c"
import script from "./InfractionDetailsPage.vue?vue&type=script&lang=js"
export * from "./InfractionDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__